// node_modules
import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
// Types
import { TTechnology } from "Types";
// styles
import styles from './technologyVotesSummaryIcon.module.scss';
// Enums
import { TechnologyVoteTypeEnum } from "Enums";

type TTechnologyVotesSummaryIconProps = {
    technology: TTechnology,
    noVoteNotification?: Boolean,
    isOutsideSidebar?: boolean,
}

export const TechnologyVotesSummaryIcon: FC<TTechnologyVotesSummaryIconProps> = ({technology, noVoteNotification, isOutsideSidebar}: TTechnologyVotesSummaryIconProps) => {
    const getPercentagePoint = (): number => {
        if (!technology.votes) return 0;
        let percentagePoint = (Math.round(technology.votes.averageVote * 100) - 100) * (-1);
        if (percentagePoint > 85) {
            return 85;
        } else {
            return percentagePoint;
        }
    }

    const getTechnologyVotesSummaryIconClass = (): string => {
        if (!technology.votes) return "";
        if (technology.votes.averageVote <= 0.3) return styles.technologyVotesSummaryIconRed;
        if (technology.votes.averageVote <= 0.45) return styles.technologyVotesSummaryIconOrange;
        if (technology.votes.averageVote <= 0.65) return styles.technologyVotesSummaryIconYellow;
        if (technology.votes.averageVote <= 0.8) return styles.technologyVotesSummaryIconLightGreen;
        if (technology.votes.averageVote <= 1.0) {
            let superLikeCount = 0;
            let totalVotesCount = 0;

            if (technology.votes.currentUserVote) {
                totalVotesCount++;
                if (technology.votes.currentUserVote.vote === TechnologyVoteTypeEnum.Super) {
                    superLikeCount++;
                }
            }

            if (technology.votes.userVotes && technology.votes.userVotes.length > 0) {
                superLikeCount += technology.votes.userVotes.filter(vote => vote.vote === TechnologyVoteTypeEnum.Super).length;
                totalVotesCount += technology.votes.userVotes.length;
            }
            
            if (superLikeCount === totalVotesCount) {
                return styles.technologyVotesSummaryIconPurple;
            } else {
                return styles.technologyVotesSummaryIconGreen;
            }
        }
        return "";
    }

    return (
        <span className="fa-layers fa-fw" style={{minWidth: "1.25rem"}}>
            {technology.votes && (technology.votes.currentUserVote || (technology.votes.userVotes && technology.votes.userVotes.length >= 1)) ?
                    <FontAwesomeIcon icon={faHeart} className={[styles.technologyVotesSummaryVoted, isOutsideSidebar ? styles.isOutsideSidebar : ""].join(" ")} />
                :
                    <FontAwesomeIcon icon={faHeart} className={styles.fontAwesomeItem} />
            }
            {technology.votes && (technology.votes.currentUserVote || (technology.votes.userVotes && technology.votes.userVotes.length >= 1)) ?
                    <FontAwesomeIcon 
                        style={{clipPath: technology.votes.averageVote > 0.99 ? "" : `inset(0 ${getPercentagePoint()}% 0 0)`}}
                        className={getTechnologyVotesSummaryIconClass()} 
                        icon={faHeart} />
                : 
                    null
            }
            {noVoteNotification && (!technology.votes || !technology.votes.currentUserVote) ? 
                    <div className={[styles.technologyNoVoteNotification, isOutsideSidebar ? styles.isOutsideSidebar : ""].join(" ")}></div>
                :
                    null
            }
            
        </span>
    );
}